import React, { useEffect, useRef, useState } from "react";
import style from "./IconSuggest.module.scss";
import { IconSearchForm } from "./IconSearchForm";
import { IconList } from "./IconList";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import { DB_ICON_TAB_LIST } from "../../../../constants/constants";
import { useTranslation } from "react-i18next";

type Props = {
  client: string;
  pageId: number;
  pageType: string;
  setCurrentIcon: React.Dispatch<React.SetStateAction<{ unicode: string | null; image_path: string | null }>>;
  isIconOpen: boolean;
  setIsIconOpen: (isOpen: boolean) => void;
  defaultImagePath: string;
};

export const IconSuggest = ({
  client,
  pageId,
  pageType,
  setCurrentIcon,
  isIconOpen,
  setIsIconOpen,
  defaultImagePath,
}: Props) => {
  const { t } = useTranslation();
  const closeRef = useRef<HTMLDivElement>(null);
  const [selectTab, setSelectTab] = useState({ tabName: t("IconSuggest.すべて"), iconKey: "recently" });
  const [iconData, setIconData] = useState({});

  const suggestStyle = (() => {
    const pageTypeStyles: Record<string, { top?: string; marginLeft?: string; marginTop?: string }> = {
      dynamic_databases: { top: "50px", marginLeft: "2px" },
      workflow_templates: { top: "180px", marginLeft: "6px" },
      sections: { marginTop: "20px", marginLeft: "2px" },
    };

    return pageTypeStyles[pageType];
  })();

  const onClickOuterClose = (e: MouseEvent) => {
    if (e.target && (e.target as HTMLElement).id === "iconImg") {
      return;
    } else if (isIconOpen) {
      if (closeRef.current && !closeRef.current.contains(e.target as Node)) {
        setIsIconOpen(false);
      }
    }
  };

  const fetchIcons = async () => {
    await axios.get(`/${client}/icons`).then((res) => {
      setIconData(res.data.icons);
    });
  };

  const onSearchIcons = async (value = null, category = null) => {
    await axios
      .get(`/${client}/icons`, {
        params: {
          category: category,
          query: value,
        },
      })
      .then((res) => {
        setIconData(res.data.icons);
      });
  };

  const deleteIcon = async () => {
    await axios
      .patch(`/${client}/icons/${pageType}/${pageId}`, {
        icon_id: null,
      })
      .then(() => {
        setCurrentIcon({ unicode: null, image_path: defaultImagePath });
      });
  };

  useEffect(() => {
    document.addEventListener("click", onClickOuterClose);
    return () => {
      if (isIconOpen) {
        document.removeEventListener("click", onClickOuterClose);
      }
    };
  }, [isIconOpen]);

  useEffect(() => {
    fetchIcons();
  }, []);

  return (
    <div className={style.pulldownField} ref={closeRef} style={suggestStyle}>
      <div
        style={{
          borderBottom: "solid 0.5px #cacaca",
          minHeight: "37px",
        }}
      >
        <ul className={`${style.tableListItem} list-unstyled main-menu d-flex pl-3 pr-4`}>
          {DB_ICON_TAB_LIST.map((tabInfo, i) => (
            <li key={i} className="d-flex align-items-center position-relative px-3">
              <div
                className="d-flex align-items-center"
                style={{ whiteSpace: "nowrap", cursor: "pointer" }}
                onClick={() => {
                  setSelectTab(tabInfo);
                }}
              >
                {tabInfo.tabName !== selectTab.tabName ? (
                  <div style={{ color: "#777777" }}>{tabInfo.tabName}</div>
                ) : (
                  <div className="dynamic-table-title  yoom-text-black font-weight-bold">{tabInfo.tabName}</div>
                )}
              </div>
              <>{tabInfo.tabName === selectTab.tabName && <div className={style.tableListItemCurrentBar} />}</>
            </li>
          ))}
          <li className={style.deleteIcon} onClick={deleteIcon}>
            {t("IconSuggest.削除")}
          </li>
        </ul>
      </div>
      <div
        style={{
          padding: "4px 0px",
          maxHeight: "170px",
          overflow: "scroll",
        }}
      >
        <IconSearchForm onSearchIcons={onSearchIcons} />
      </div>
      <IconList
        client={client}
        pageId={pageId}
        pageType={pageType}
        selectTab={selectTab}
        iconData={iconData}
        setCurrentIcon={setCurrentIcon}
        setIsIconOpen={setIsIconOpen}
      />
    </div>
  );
};
